export enum ProvinceEnumerator {
    ISLAMABAD = 'islamabad',
    PUNJAB = 'punjab',
    SINDH = 'sindh',
    KPK = 'kpk',
    BALOCHISTAN = 'balochistan',
    GILGIT_BALTISTAN = 'gilgit_baltistan',
}